import { cn } from "@bowfast/ui/lib/utils";
import type { ActivityEntry } from "~/pages/expeditions/expedition-detail.mock";

export const ACTIVITY_DOT_COLOR: Record<ActivityEntry["color"], string> = {
  success: "bg-shallow-500",
  warning: "bg-signal-500",
  primary: "bg-abyss-500",
  neutral: "bg-muted-foreground/40",
};

export function ActivityItem({ entry, isLast }: Readonly<{ entry: ActivityEntry; isLast: boolean }>) {
  return (
    <div className="flex gap-3 px-5 py-3">
      <div className="flex flex-col items-center pt-1.5">
        <div className={cn("size-2 shrink-0 rounded-full", ACTIVITY_DOT_COLOR[entry.color])} />
        {!isLast && <div className="mt-1 w-px flex-1 bg-border" />}
      </div>
      <div className="min-w-0 flex-1 pb-1">
        <p className="text-sm font-medium">{entry.title}</p>
        <p className="text-xs text-muted-foreground">{entry.detail}</p>
      </div>
      <span className="shrink-0 pt-0.5 text-xs tabular-nums text-muted-foreground">{entry.timeLabel}</span>
    </div>
  );
}
